import React from "react";
import { SubsectionWithFields } from "./sections/subsection/fields";
import { SearchCommonField } from "./inputs/common-field";
import { SearchResultsButton } from "./components/results-button";
import { Button } from "@mui/material";
import { SearchFormMobile } from "./search-form-mobile";
import loadable from "@loadable/component";

const SearchGlobe = loadable(() => import("./components/globe"));

type TeaserFormMobileProps = {
    compact?: boolean;
    className?: string;
};

export const TeaserFormMobile = ({
    className,
    compact = true
}: TeaserFormMobileProps) => {
    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        setOpen(false);
    };
    return (
        <>
            <div
                className={`shadow-standard mx-auto w-[90vw] max-w-[900px] rounded-lg  bg-white px-4 pt-8 pb-4 sm:px-8 ${className}`}
            >
                <SubsectionWithFields>
                    <SearchCommonField name="continent" />
                    <SearchCommonField name="focus" />
                    <SearchCommonField name="month" />
                    <SearchCommonField name="weather.tmax" />
                </SubsectionWithFields>
                <div
                    className={`flex ${
                        compact
                            ? "gap-[12px] py-[16px] xsm:gap-[16px] xsmax:flex-col"
                            : "flex-col gap-[8px] "
                    } items-center justify-center px-[16px] pb-[8px] xm:flex-row xm:gap-[32px] xm:py-[16px]`}
                >
                    <SearchGlobe
                        isSmall={compact}
                        fallback={
                            <div
                                className={`${
                                    compact ? "h-[175px] w-[175px]" : "h-[230px] w-[230px]"
                                }`}
                            />
                        }
                    />
                    <div className="flex flex-col gap-4 xmmax:w-full">
                        <SearchResultsButton />
                        <Button
                            variant="outlined"
                            onClick={() => setOpen(true)}
                        >
                            More filters
                        </Button>
                    </div>
                </div>
            </div>
            <SearchFormMobile open={open} handleClose={handleClose} />
        </>
    );
};
